// Lib
import useUpdateEffect from './useUpdateEffect';

/**
 * When the value becomes true, the elementRef will be focused.
 *
 * NOTE: If the value is true on mount, this will ignore it and will only focus the next time it's true.
 */
const useFocusOnTrue = (elementRef, value, delay = 0) => {
    useUpdateEffect(() => {
        const focusElement = () => {
            if (!value || !elementRef || !elementRef.current) return;

            elementRef.current.focus();
        };

        if (!delay) {
            focusElement();
            return;
        }

        setTimeout(() => {
            focusElement();
        }, delay);
    }, [value]);
};

export default useFocusOnTrue;
